import {useEffect, useRef} from 'react';

import _ from '../../utils/_';
import elementFactory from '../../utils/element';
import carouselScrollFactory from '../../../vendors/bootstrap/components/carousel-scroll.js';
import {carouselScrollMock} from '../../../vendors/bootstrap/components/carousel-scroll.js';

const useCarouselScroll = (
    target,
    options: optionsType = {},
    externalDependencies: any = [],
) => {
  const instanceRef = useRef(carouselScrollMock());

  useEffect(() => {
    const $ = elementFactory(document, window);
    const carousel = carouselScrollFactory(window, $, _);
    const instance = carousel(
        options,
        $.find('.carousel-scroll-inner', target.current),
        $.findAll('.carousel-scroll-item', target.current),
        $.find('.carousel-scroll-control-prev', target.current),
        $.find('.carousel-scroll-control-next', target.current),
        $.findAll('[data-slide-to]', target.current),
    );

    instanceRef.current = instance;

    return () => {
      instance.destroy();
    };
  }, [target.current, ...externalDependencies]);

  return instanceRef;
};

interface optionsType {
  duration?: number;
  easing?: (t, b, c, d) => number;
  vertical?: boolean;
  step?: number;
  start?: number;
  onScroll?: (activeIndex) => any;
}

export default useCarouselScroll;
